import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link as ButtonLink } from '@innovationnorway/component-library';
import { Link } from 'react-router-dom';
import invite1 from 'src/assets/img/invite_1.svg';
import invite2 from 'src/assets/img/invite_2.svg';
import invite3 from 'src/assets/img/invite_3.svg';
import CreateLinkToOpportunityForm from 'src/features/one-way-in/components/create-link-form/CreateLinkToOpportunityForm';

const Invite: React.FC = () => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');

  return (
    <div className="stack-large">
      <h2>{tHelpAndSupport('commonQuestions.Invite')}</h2>
      <div className="stack-medium">
        <img className="margin-x--auto display--block" alt="hei" src={invite2}></img>
        <h3 className="font-weight--bold">{tHelpAndSupport('commonQuestions.Invite.Self.Header')}</h3>
        <p>{tHelpAndSupport('commonQuestions.Invite.Self.Text')}</p>
        <p>{tHelpAndSupport('commonQuestions.Invite.Self.Text2')}</p>
        <CreateLinkToOpportunityForm />
        <ButtonLink
          onClick={() => {
            const sidebar = document.getElementsByClassName('drawer-side-menu__menu')[0];
            sidebar.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            window.dispatchEvent(
              new CustomEvent('openSideMenu', {
                detail: 'index/commonQuestions/owi/journey',
              }),
            );
          }}
        >
          {tHelpAndSupport('commonQuestions.Invite.Self.Link')}
        </ButtonLink>
      </div>
      <div className="stack-medium">
        <img className="margin-x--auto display--block" alt="hei" src={invite3}></img>
        <h3 className="font-weight--bold">{tHelpAndSupport('commonQuestions.Invite.Others.Header')}</h3>
        <Trans
          t={tHelpAndSupport}
          i18nKey={'commonQuestions.Invite.Others.Text'}
          components={{
            '1': <Link to={'https://enveiinn.no'}>enveiinn.no</Link>,
          }}
        ></Trans>
      </div>
      <div className="stack-medium">
        <img className="margin-x--auto display--block" alt="hei" src={invite1}></img>
        <h3 className="font-weight--bold">{tHelpAndSupport('commonQuestions.Invite.Create.Header')}</h3>
        <p>{tHelpAndSupport('commonQuestions.Invite.Create.Text')}</p>
        <Link className="display--block" to={'/graphical'}>
          {tHelpAndSupport('commonQuestions.Invite.Create.Link')}
        </Link>
      </div>
    </div>
  );
};

export default Invite;
